import axios from '@axios'

export const state = {
  users: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
}

export const getters = {
  allUsers: (state) => state.users,
  otp: (state) => state.otp,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_USERS: (state, resp) => {
    if (!resp) return null
    state.users = resp.users
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  CREATE_USER: (state, user) => {
    if (!user) return null
    state.users.push(user)
  },
  UPDATE_USER: (state, user) => {
    if (!user) return null
    for (let i = 0; i < state.users.length; i++) {
      if (state.users[i].id === user.id) {
        for (let field in state.users[i]) {
          state.users[i][field] = user[field]
        }
        break
      }
    }
  },
}

export const actions = {
  async getUsers({ commit }, params) {
    await axios
      .get(`/api/users`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          let data = resp.data
          commit('GET_USERS', data)
        }
      })
      .catch(() => {
        commit('GET_USERS', null)
      })
      .finally(() => {})
  },

  async createUser({ commit }, form) {
    await axios
      .post('/api/users', form)
      .then((resp) => {
        if (resp.status === 200) {
          commit('CREATE_USER', Object.assign({}, resp.data))
        }
      })
      .catch(() => {
        commit('CREATE_USER', null)
      })
  },
  async updateUser({ commit, rootGetters }, form) {
    await axios
      .put('/api/users', form)
      .then((resp) => {
        if (resp.status === 200) {
          commit('UPDATE_USER', Object.assign({}, resp.data))
          if (rootGetters['auth/currentUser'].id === form.id) {
            commit('auth/SET_PROFILE', Object.assign({}, resp.data), {
              root: true,
            })
          }
        }
      })
      .catch(() => {
        commit('UPDATE_USER', null)
      })
  },
  async changePassword({ commit }, form) {
    return axios.patch('/api/users', form)
  },
  async userSignUp({ commit }, form) {
    return axios.post('/api/signup', form)
  },
  async confirmOtp({ commit }, otp) {
    return axios.post('/api/confirm-otp', otp)
  },
  async forgotPassword({ commit }, phoneNumber) {
    return axios.patch('/api/forgot-password', { phone_number: phoneNumber })
  },
  async confirmOtpPhone({ commit }, otp) {
    return axios.post('/api/confirm-otp-phone', otp)
  },
}
